import type { FC } from "react";

import { cn } from "../utils";
import { Group, type GroupProps } from "./group";

export interface ButtonGroupProps extends GroupProps {}

export const ButtonGroup: FC<ButtonGroupProps> = ({ className, ...props }) => (
  <Group
    type="flex"
    direction="row"
    {...props}
    className={cn("flex-wrap flex-1 gap-2 items-center justify-end", className)}
  />
);
